module.exports = __webpack_public_path__ + "img/dl-mac-sr.555823d1.png";